<template>
  <a-breadcrumb class="breadcrumb">
    <a-breadcrumb-item><a-icon type="home" /></a-breadcrumb-item>
    <a-breadcrumb-item v-for="(item,index) in $route.meta.breadcrumb" :key="index"><span @click="jump(item)">{{ item.name }}</span></a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    jump (item) {
      if (this.$route.path !== item.url) {
        this.$router.push({path: item.url})
      }
    }
  }
}
</script>

<style scoped>
span{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/center/Breadcrumb.vue